import { render, staticRenderFns } from "./ModalCadastroOcorrencias.vue?vue&type=template&id=2d2aac3e&scoped=true"
import script from "./ModalCadastroOcorrencias.vue?vue&type=script&lang=js"
export * from "./ModalCadastroOcorrencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2aac3e",
  null
  
)

export default component.exports